import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const trashedPlanDirectLinkRoute: InvariantJiraRoute = {
	name: 'trashed-plan-direct-link',
	path: '/jira/plans/plan-trashed',
	exact: true,
};
